import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
} from "chart.js";
import moment from "moment";
import CardCommon from "../../../../components/card/CardCommon";
import ChartType from "./ChartType";
import { zeroToTwentyThreeList } from "../../../../utils/consts/list";
import { enumerateDaysBetweenDates } from "../../../../utils/enumerateDaysBetweenDates";

ChartJS.register(
  Title,
  Tooltip,
  LineElement,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
);

export interface ChartReportInfoNodeProps {
  currentDashboardNodeList: any;
  previousDashboardNodeList: any;
  paymentNodeList: any;
  previousPaymentNodeList: any;
  previousStartDate: any;
  previousEndDate: any;
  currentStartDate: any;
  currentEndDate: any;
  ordersNodeList: any;
  previousOrdersNodeList: any;
  averageNodeList: any;
  previousAverageNodeList: any;
  platformNodeList: any;
  previousPlatformNodeList: any;
  modeNodeList: any;
  previousModeNodeList: any;
  channelNodeList: any;
  previousChannelNodeList: any;
  isEmpty?: any;
  currentSalesTotal: any;
  previousSalesTotal: any;
  salesTotalNode:any
}

/*
 * ChartReportInfoNode is a React functional component responsible for rendering various types of charts
 * based on the provided data. It receives props such as currentDashboardNodeList, previousDashboardNodeList,
 * paymentNodeList, previousPaymentNodeList, previousStartDate, previousEndDate, currentStartDate,
 * currentEndDate, ordersNodeList, previousOrdersNodeList, averageNodeList, previousAverageNodeList,
 * platformNodeList, previousPlatformNodeList, modeNodeList, previousModeNodeList, channelNodeList,
 * previousChannelNodeList, isEmpty, currentSalesTotal, and previousSalesTotal.
 * The component utilizes useEffect hook to calculate and set the shortPreviousDateRange and shortCurrentDateRange
 * based on the selected date ranges and adjust them to have equal lengths if necessary.
 * It renders a CardCommon component containing a ChartType component which in turn renders different types of charts
 * based on the provided data and date ranges.
 * The component is styled using Material-UI's Grid component with custom marginTop.
 */
const ChartReportInfoNode: React.FunctionComponent<
  ChartReportInfoNodeProps
> = ({
  currentDashboardNodeList,
  previousDashboardNodeList,
  paymentNodeList,
  previousPaymentNodeList,
  previousStartDate,
  previousEndDate,
  currentStartDate,
  currentEndDate,
  ordersNodeList,
  previousOrdersNodeList,
  averageNodeList,
  previousAverageNodeList,
  platformNodeList,
  previousPlatformNodeList,
  modeNodeList,
  previousModeNodeList,
  channelNodeList,
  previousChannelNodeList,
  isEmpty,
  currentSalesTotal,
  previousSalesTotal,salesTotalNode
}) => {
  const [shortCurrentDateRange, setShortCurrentDateRange] = useState<any>([]);

  /* This equates the number of days in the previous date range to the 
     number of days in the current date range. Then the date ranges are sorted. */
  useEffect(() => {
    /* If the current start date and the current end date are unequal, 
    the date range to be displayed on the chart's x-axis is created using the start date and the end date. */
      const currentDateRange = enumerateDaysBetweenDates(
        currentStartDate,
        currentEndDate,
      );
      /* This works if the data in the current date range is equal to this month. */

      /* Sort the previous and current date range */
      const shortCurrentDateRange = currentDateRange.sort();

      setShortCurrentDateRange(shortCurrentDateRange);
   
  }, [currentStartDate, currentEndDate, paymentNodeList]);
  return (
    <>
      <Grid container spacing={2} style={{ marginTop: "14px" }}>
        <Grid item xs={12}>
          <ChartType
            previousStartDate={previousStartDate}
            previousEndDate={previousEndDate}
            currentStartDate={currentStartDate}
            currentEndDate={currentEndDate}
            shortCurrentDateRange={shortCurrentDateRange}
            previousDashboardNodeList={previousDashboardNodeList}
            currentDashboardNodeList={currentDashboardNodeList}
            paymentNodeList={paymentNodeList}
            previousPaymentNodeList={previousPaymentNodeList}
            ordersNodeList={ordersNodeList}
            previousOrdersNodeList={previousOrdersNodeList}
            averageNodeList={averageNodeList}
            previousAverageNodeList={previousAverageNodeList}
            platformNodeList={platformNodeList}
            previousPlatformNodeList={previousPlatformNodeList}
            modeNodeList={modeNodeList}
            previousModeNodeList={previousModeNodeList}
            channelNodeList={channelNodeList}
            previousChannelNodeList={previousChannelNodeList}
            isEmpty={isEmpty}
            currentSalesTotal={currentSalesTotal}
            previousSalesTotal={previousSalesTotal}
            salesTotalNode={salesTotalNode}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ChartReportInfoNode;
